<template>

    <v-section name="HTML" :expanded="expanded">
        <v-textarea-variable :rows="10" :model="code" @input="onInput($event)" />
    </v-section>

</template>

<script>

import Section from './Section';

export default {

    components: {
        'v-section': Section,
    },

    props: {
        expanded: {
            type: Boolean,
            default: false,
        },
    },

    mounted() {
        this.code = Object.assign({}, this.block).code;
    },

    data() {
        return {
            code: null,
        }
    },

    computed: {

        block() {
            return this.$store.getters['builder/selectedBlock'];
        },

    },

    methods: {

        onInput(val) {
            let block = this.block;
            this.block['code'] = val;
            this.$store.commit('builder/setSelectedBlock', block);
        },

    },

}

</script>